const getModuleState = (state) => state.driverStats;

export const getGame = (state) => getModuleState(state).game;
